import { render, staticRenderFns } from "./ChooseDiseasesTable.vue?vue&type=template&id=62c52ffc&scoped=true&"
import script from "./ChooseDiseasesTable.vue?vue&type=script&lang=js&"
export * from "./ChooseDiseasesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c52ffc",
  null
  
)

export default component.exports